import { Box } from '@mui/material';
import { useVersionCheck } from '../lib/useVersionCheck';
import Link from 'components/common/Link';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useEffect, useState } from 'react';
import { sendApiRequest } from 'lib/api/public';
import { IChangelog } from './ChangelogAnnouncement';

export default function VersionChecker() {
  const { currentVersion } = useVersionCheck(60000, true);
  const [showBell, setShowBell] = useState(false);

  useEffect(() => {
    const checkChangelogStatus = async () => {
      try {
        const response = (await sendApiRequest({
          path: '/changelog/latest',
          method: 'GET',
        })) as { changelog: IChangelog | null };
        // If we get a changelog response, it means user hasn't read it
        setShowBell(!!response.changelog);
      } catch {
        // If there's an error, don't show the bell
        setShowBell(false);
      }
    };

    void checkChangelogStatus();
  }, []);

  const handleClick = async () => {
    if (showBell) {
      try {
        await sendApiRequest({
          path: '/changelog/mark-as-read',
          method: 'POST',
        });
        setShowBell(false);
      } catch {
        // Handle error silently
      }
    }
  };

  return (
    <Link href="/changelog" style={{ textDecoration: 'none' }}>
      <Box
        onClick={handleClick}
        sx={{
          backgroundColor: 'rgba(30, 41, 59, 0.65)',
          margin: '0 8px 8px',
          color: 'white',
          fontSize: '11px',
          padding: '6px 16px',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          cursor: 'pointer',
          justifyContent: 'center',
        }}
      >
        <span style={{ fontWeight: 'bold', letterSpacing: '0.5px' }}>Version: </span>
        <span style={{ fontWeight: 500 }}>{currentVersion?.version || ''}</span>
        {showBell && (
          <Box sx={{ position: 'relative', marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
            <Box sx={{ position: 'relative' }}>
              <NotificationsIcon
                sx={{
                  fontSize: '18px',
                  color: '#ffffff',
                  filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: '-3px',
                  right: '-3px',
                  width: '10px',
                  height: '10px',
                  backgroundColor: '#ff0000',
                  borderRadius: '50%',
                  border: '2px solid #ffffff',
                  boxShadow: '0 2px 4px rgba(255, 0, 0, 0.4)',
                }}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Link>
  );
}
